import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Menu from "../../../components/Menu";
import Loading from "../../../components/Loading";

import api from "../../../services/api";

const initialState = {
    id: null,
    descricao: "",
    compras_produto_tipo_id: "",
    estoque: false,
    natureza: ""
}

const OPTIONS_BOOLEAN = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false }
];

export default function Produtos() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});
    const [search, setSearch] = useState("");
    const [types, setTypes] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get("produtos").then((response) => {
            setData(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    const handleEdit = rowData => {
        setForm({...rowData});
        setIsVisible(true);
    }

    const handleSubmit = _ => {
        if(form.id !== null) {
            setIsLoading(true);
            api.put(`produtos/${form.id}/update`).then((response) => {
                fetchData();
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const onHide = _ => setIsVisible(false);

    const renderFooter = _ => {
        return (
            <div>
                <Button className="p-button-secondary" label="Cancelar" onClick={onHide} />
                <Button className="p-button-success" label="Salvar" onClick={handleSubmit} />
            </div>
        )
    }

    useEffect(() => {
        api.get("produto-tipos").then((response) => {
            setTypes(response.data);
        }).catch((error) => {
            setTypes([]);
        });

        fetchData();
    }, [fetchData]);

    if(isLoading)
        return <Loading />

    const filteredData = search.length > 0 ? data.filter((element) => {
        return String(element.descricao).toUpperCase().includes(search.toUpperCase());
    }) : data;

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Produtos"
            >
                <Dialog
                    footer={renderFooter}
                    header="Editar Produto"
                    onHide={onHide}
                    style={{ minWidth: "30vw" }}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-grid">
                            <div className="p-field p-col-4">
                                <label htmlFor="id">ID: </label>
                                <InputText 
                                    readOnly
                                    value={form.id}
                                />
                            </div>  
                            <div className="p-field p-col-8">
                                <label htmlFor="descricao">Descrição: </label>
                                <InputText 
                                    readOnly
                                    value={form.descricao}
                                />
                            </div>  
                        </div>
                        <div className="p-field">
                            <label htmlFor="compras_produto_tipo_id">Tipo Produto: </label>
                            <Dropdown 
                                emptyMessage="Nenhum registro encontrado."
                                onChange={e => setForm({...form, compras_produto_tipo_id: e.value })}
                                options={types}
                                optionLabel="nome"
                                optionValue="id"
                                placeholder="Sim ou Não"
                                value={form.compras_produto_tipo_id}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="estoque">Estocável?</label>
                            <Dropdown 
                                emptyMessage="Nenhum registro encontrado."
                                onChange={e => setForm({...form, estoque: e.value })}
                                options={OPTIONS_BOOLEAN}
                                placeholder="Sim ou Não"
                                value={form.estoque}
                            />
                        </div>
                    </div>
                </Dialog>

                <div className="p-d-flex p-flex-row p-jc-end">
                    <InputText 
                        className="p-m-2"
                        onChange={e => setSearch(e.target.value)}
                        placeholder="Descrição do produto"
                        value={search}
                    />
                </div>

                <DataTable
                    paginator
                    rows={15}
                    rowsPerPageOptions={[15, 30, 50, 100]}
                    responsiveLayout="scroll"
                    size="small"
                    value={filteredData}
                >
                    <Column header="ID" field="id" sortable />
                    <Column header="Descrição" field="descricao" sortable />
                    <Column header="Tipo" field="tipo" sortable />
                    <Column header="Natureza" field="natureza" sortable />
                    <Column header="Estocável" body={(rowData) => (
                        <span>{rowData.estoque === true ? "Sim" : "Não"}</span>
                    )} sortable />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button icon="pi pi-pencil" onClick={() => handleEdit(rowData)} />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}